module.exports = __webpack_public_path__ + "sd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sd.svg
// module id = 793
// module chunks = 0